import { __decorate as t, __classPrivateFieldGet as s, __classPrivateFieldSet as e } from "tslib";
import { LitElement as i, html as o } from "lit";
import { property as r } from "lit/decorators.js";
import l from "../../../styles/global-styles.js";
import n from "./mobile-item-styles.js";
var c;
class u extends i {
  constructor() {
    super(...arguments), c.set(this, !1);
  }
  get unresponsive() {
    return s(this, c, "f");
  }
  set unresponsive(t) {
    e(this, c, t, "f");
  }
  get link() {
    return this.querySelector("a");
  }
  get icon() {
    return this.querySelector(".ids-icon");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.setupIcon();
  }
  setupIcon() {
    this.icon && (this.icon.setAttribute("slot", "icon"), this.icon.setAttribute("width", "30"), this.icon.setAttribute("height", "30"), this.icon.setAttribute("colorpreset", "2"));
  }
  click() {
    this.link?.click();
  }
  render() {
    return o`<button @click="${this.click}" aria-label="${this.link?.textContent || ""}" class="btn-no-styles"><ids-col class="ids-mr-1" cols="auto"><slot name="icon"></slot></ids-col><ids-col class="mobile-item-text" cols="auto">${this.link?.textContent} <span class="hide"><slot></slot></span></ids-col></button>`;
  }
}
c = new WeakMap(), u.styles = [l, n], t([r({
  type: Boolean,
  reflect: !0
})], u.prototype, "unresponsive", null);
export { u as IDSHeaderMobileItem };